import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import {
  trigger,
  style,
  transition,
  animate,
  group,
} from '@angular/animations';
import {
  ToastMessage,
  ToastService,
  ToastSeverity,
  ToastPosition,
} from '@services/toast/toast.service';

@Component({
    selector: 'app-toast',
    imports: [CommonModule],
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    animations: [
        trigger('rightAnimation', [
            transition(':enter', [
                style({ transform: 'translateX(100%)', opacity: 0 }),
                animate('300ms ease-out', style({ transform: 'translateX(0)', opacity: 1 })),
            ]),
            transition(':leave', [
                group([
                    animate('300ms ease-in', style({ opacity: 0 })),
                    animate('300ms ease-in', style({ transform: 'translateX(100%)' })),
                ]),
            ]),
        ]),
        trigger('leftAnimation', [
            transition(':enter', [
                style({ transform: 'translateX(-100%)', opacity: 0 }),
                animate('300ms ease-out', style({ transform: 'translateX(0)', opacity: 1 })),
            ]),
            transition(':leave', [
                group([
                    animate('300ms ease-in', style({ opacity: 0 })),
                    animate('300ms ease-in', style({ transform: 'translateX(-100%)' })),
                ]),
            ]),
        ]),
    ]
})
export class ToastComponent implements OnInit, OnDestroy {
  @Input() position: ToastPosition = 'bottom-right';

  topRightToasts: ToastMessage[] = [];
  topLeftToasts: ToastMessage[] = [];
  bottomRightToasts: ToastMessage[] = [];
  bottomLeftToasts: ToastMessage[] = [];

  private subscription: Subscription = new Subscription();

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    this.subscription = this.toastService.toasts$.subscribe((toasts) => {
      this.topRightToasts = toasts.filter(
        (toast) => (toast.position || this.position) === 'top-right'
      );

      this.topLeftToasts = toasts.filter(
        (toast) => (toast.position || this.position) === 'top-left'
      );

      this.bottomRightToasts = toasts.filter(
        (toast) => (toast.position || this.position) === 'bottom-right'
      );

      this.bottomLeftToasts = toasts.filter(
        (toast) => (toast.position || this.position) === 'bottom-left'
      );
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  removeToast(id: number): void {
    this.toastService.remove(id);
  }

  getIcon(severity: ToastSeverity): string {
    switch (severity) {
      case ToastSeverity.SUCCESS:
        return 'check_circle';
      case ToastSeverity.INFO:
        return 'info';
      case ToastSeverity.WARN:
        return 'warning';
      case ToastSeverity.ERROR:
        return 'error';
      default:
        return 'info';
    }
  }
}
